import { del } from "../../../utils/axios-config";
import { SUBSCRIPTIONS } from "../../../utils/constants";

export const deleteSubscriptionByEnrollmentId = async (id: string) => await del<any, boolean>(SUBSCRIPTIONS, {
    id, idEnrollment:id
});